export const TICKET360_TABS = [
  { id: 'conversation', label: 'Conversation' },
  { id: 'overview', label: 'Overview' },
  { id: 'related', label: 'Related' },
];

export const TICKET_STATUS_LABELS = {
  1: 'New',
  2: 'Assigned',
  3: 'In Progress',
  4: 'Pending',
  5: 'Resolved',
  6: 'Closed',
};

export const TICKET_PRIORITY_LABELS = {
  1: 'Critical',
  2: 'High',
  3: 'Medium',
  4: 'Low',
};

export const TICKET_CATEGORY_LABELS = {
  1: 'Sales',
  2: 'Support',
  3: 'Enquiry',
  4: 'Suggestion',
};
